export function formatDate(data){

    return data.split("-").reverse().join("/");
}